import { m as motion, AnimatePresence } from 'framer-motion';
import { Text } from '@etg/wings';
import { ScreenReaderPrice } from '@eti/components';
import { CABIN_UPGRADE } from '../../../products';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const AnimatePrice = _ref => {
  let {
    textVariant,
    totalPrice
  } = _ref;
  if (!totalPrice) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ScreenReaderPrice, {
      price: totalPrice
    }), /*#__PURE__*/_jsx(AnimatePresence, {
      children: /*#__PURE__*/_jsx(motion.div, {
        animate: {
          scale: 1,
          opacity: 1
        },
        initial: {
          scale: 0.95,
          opacity: 0.5
        },
        transition: {
          type: 'spring',
          stiffness: 300,
          damping: 100
        },
        children: /*#__PURE__*/_jsx(Text, {
          "aria-hidden": "true",
          "data-testid": `${CABIN_UPGRADE.name}-drawer-summary-price`,
          variant: textVariant,
          children: totalPrice
        })
      }, totalPrice)
    })]
  });
};
export default AnimatePrice;
//# sourceMappingURL=AnimatePrice.js.map